'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./toggle-switch.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)('div', {
    className: 'sb-toggle-switch__slider'
});
// css


/**
 * WH ToggleSwitch Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
var ToggleSwitch = function (_Component) {
    (0, _inherits3.default)(ToggleSwitch, _Component);

    function ToggleSwitch(props) {
        (0, _classCallCheck3.default)(this, ToggleSwitch);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ToggleSwitch.__proto__ || (0, _getPrototypeOf2.default)(ToggleSwitch)).call(this, props));

        _this.handleOnChange = function () {
            var _this$props$onChange = _this.props.onChange,
                onChange = _this$props$onChange === undefined ? function () {} : _this$props$onChange;


            _this.setState({
                isOn: !_this.state.isOn
            });

            onChange();
        };

        _this.state = {
            isOn: _this.props.isOn || false
        };
        return _this;
    }

    (0, _createClass3.default)(ToggleSwitch, [{
        key: 'render',
        value: function render() {
            var _cx;

            var _props = this.props,
                _props$className = _props.className,
                className = _props$className === undefined ? '' : _props$className,
                _props$size = _props.size,
                size = _props$size === undefined ? '' : _props$size,
                name = _props.name,
                id = _props.id;


            var classNames = (0, _classnames2.default)((_cx = {
                'sb-toggle-switch': true,
                'sb-toggle-switch--active': this.state.isOn
            }, (0, _defineProperty3.default)(_cx, 'sb-toggle-switch--' + size, size), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

            return (0, _jsx3.default)('label', {
                htmlFor: id,
                className: classNames
            }, void 0, (0, _jsx3.default)('input', {
                id: id,
                className: 'sb-toggle-switch__checkbox',
                type: 'checkbox',
                name: name,
                onChange: this.handleOnChange,
                checked: this.state.isOn
            }), _ref);
        }
    }]);
    return ToggleSwitch;
}(_react.Component);

exports.default = ToggleSwitch;
//# sourceMappingURL=ToggleSwitch.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/toggleSwitch/ToggleSwitch.js
// module id = 620
// module chunks = 0